import React from 'react';
import { Container, Section } from '../components/ui/Section';
import { PageHeader } from '../components/ui/PageHeader';
import { ChurchDirectory } from '../components/churches/ChurchDirectory';
import { DoodleScatter } from '../components/brand/DoodleScatter';
import { localChurches } from '../data/churches';
export function LocalChurches() {
  return <>
      <PageHeader eyebrow="Get Connected" title="Local Churches" intro="Aside from your commitment to BCM, we want you to get connected to one of our trusted local churches." seed="local-churches-header" data-id="element-540" data-mp="2pvsr0bf7aza5" />

      <Section className="relative overflow-hidden bg-[#fffdf6] py-14 sm:py-18" labelledBy="church-directory-heading" data-id="element-541" data-mp="3djadbrfp555q">
        <DoodleScatter tone="white" seed="local-churches" data-id="element-542" data-mp="38m0nwbsb4thw" />
        <Container className="relative" data-id="element-543" data-mp="3mkqm5uqv4z7u">
          <h2 id="church-directory-heading" className="sr-only" data-id="element-544" data-mp="3mhmc4gqpv999">
            Trusted local churches
          </h2>
          <ChurchDirectory churches={localChurches} data-id="element-545" data-mp="aqs4luzwzrnq" />
        </Container>
      </Section>
    </>;
}